import { LICENSE_TYPE } from 'Pods/SearchPage/Store/constants'

// No "All" option: nothing checked means every license (the store keeps [LICENSE_TYPE.ALL] then).
const licenseFilters = [
  {
    value: LICENSE_TYPE.ROYALTY_FREE,
    labelKey: 'royalty_free',
  },
  {
    value: LICENSE_TYPE.EDITORIAL,
    labelKey: 'editorial',
  },
  {
    value: LICENSE_TYPE.CUSTOM,
    labelKey: 'custom',
  },
]

// Unlabeled: every caller (More filters popover, All Filters drawer) titles the section itself.
export const getLicenseFiltersConfig = (translate) => {
  return [{
    label: '',
    filters: licenseFilters.map(filter => ({
      value: filter.value,
      label: translate(`search_page.filters.license.${filter.labelKey}`),
    })),
  }]
}
